export default {
  Title: 'Elasticities',
  Tab  : {
    Regressions: {
      Title: 'Regressions',
      Slug : 'regressions'
    },
    Peers: {
      Title: 'Peers',
      Slug : 'peers'
    }
  },
  Section: {
    FranchiseStrength: {
      Title         : 'Franchise Strength',
      Tooltip       : 'MISSING TOOLTIP',
      CurrentQuarter: 'Current Quarter',
      '12MonthsAgo' : '12 Months ago',
      Strength      : 'Strength'
    },
    MarginSpread: {
      Title                  : 'Margin Spread',
      Tooltip                : 'MISSING TOOLTIP',
      MarginSpreadSensitivity: 'Margin Spread Sensitivity with Interest Rates'
    },
    NetInterestIncomeSensitivity: {
      Title                       : 'Net Interest Income Sensitivity',
      Tooltip                     : 'MISSING TOOLTIP',
      NetInterestIncomeSensitivity: 'NII Sensitivity with Interest Rates and Curve Slope'
    },
    RepricingSpeed: {
      Title        : 'Repricing Speed',
      TitleInfo    : 'Repricing Speed',
      Tooltip      : 'MISSING TOOLTIP',
      Loans        : 'Loans',
      Deposits     : 'Deposits',
      CurrentSpeed : 'Current Speed',
      LastYearSpeed: 'Last Year Speed',
      Speed        : 'Speed',
      Loan         : 'Loan',
      Deposit      : 'Deposit'
    },
    PeersNIISensitivity: {
      Title    : 'Peers NII Sensitivity',
      TitleInfo: 'Peers NII Sensitivity',
      Tooltip  : 'MISSING TOOLTIP'
    }
  }
}
